import React, {type FC} from 'react'
import {LettersBox, type KeyboardViewType} from 'uikit'
import {useAppSelector} from 'store'
import {getLetters, getAlphaBetView} from 'store/letter/selectors'
import {type PropsLettersBoxView} from './types'

const PREFIX = 'alphabet-'

export const AlphaBetView: FC<PropsLettersBoxView> = ({onLetterClick}) => {
  const letters = useAppSelector(getLetters)
  const view = useAppSelector(getAlphaBetView)

  const countOfLetters = Math.round(view.length / 3)
  const view3lines: KeyboardViewType = []
  view3lines.push(view.slice(0, countOfLetters))
  view3lines.push(view.slice(countOfLetters, countOfLetters*2))
  view3lines.push(view.slice(countOfLetters*2))

  return <LettersBox view={view3lines} letters={letters} prefix={PREFIX} onLetterClick={onLetterClick} />
}
